const styles = theme => ({
    root: {
        minHeight: '300px',
        width: '700px'
    },
    action: {
        alignItems: 'center',
        flexDirection: 'row',
        paddingTop: '30px',
    },
    instructions: {
        flexDirection: 'column',
        alignItems: 'start',
        fontFamily: 'AvenirNext',
        fontSize: '13px',
        fontWeight: '500',
        fontStretch: 'normal',
        fontStyle: 'italic',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4a4a4a'
    },
    fileName: {
        fontFamily: 'AvenirNext',
        fontSize: '13px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        color: '#4a4a4a',
        margin: '0 0 0 0px'
    },
    groupControlSelect: {marginTop: '20px', marginBottom: '20px'},
    label: {
        fontFamily: 'AvenirNext-DemiBold',
        fontSize: '14px',
        fontWeight: 600,
        color: '#96979a',
        marginBottom: '5px'
    },
    file: {alignItems: 'center', margin: '10px 10px 0px 10px'},
    title: {
     marginLeft: '24px',
    },
    titleWrapper: {
        paddingBottom: '4px',
    },
    subTitle: {
       marginTop: '0px',
       paddingTop: '0px',
    },
    uploadArea: {
        fontFamily: "AvenirNext",
        fontSize: 14,
        fontWeight: "600",
        fontStyle: "normal",
        letterSpacing: 0,
        color: "#4a4a4a"
    },
    uploadAction: {
        marginLeft: 15,
        width: '100%',
    },
    fileInfo: {
        fontFamily: "AvenirNext",
        fontWeight: "500",
        fontStyle: "normal",
        letterSpacing: 0,
        color: "#4a4a4a",
    },
    uploadedFileName: {
        overflow: 'hidden',
        textOverflow: "ellipsis",
        width: '100%'
    },
    removeFile: {
        cursor: 'pointer'
    },
})
export default styles;


